module.exports = __webpack_public_path__ + "files/f52ffeaa98cf608cbbd3aadfed497021.png";